import { Col } from "@commonlibs";
import styled, { css } from "styled-components";

export const MainDrawerBodyRoot = styled(Col)(
    ({ theme }) => css`
        padding: ${theme.spacing.all(10, 8)};
        .logout-btn {
            cursor: pointer;
            &:hover {
                text-decoration: underline;
            }
        }
    `,
);
